import { HEADER_ACCEPT_CURRENCY } from "./HEADER_ACCEPT_CURRENCY";

export const COOKIE_CURRENCY_OVERRIDE = HEADER_ACCEPT_CURRENCY;
